<template>
  <div>
    <input
      type="range"
      :min="min"
      :max="max"
      :value="value"
      class="t-Slider"
      @change="(e) => handleChange(e.target.value)"
    >
  </div>
</template>

<script>
export default {
  name: 'TSlider',
  props: {
    max: { type: Number, default: 10 },
    min: { type: Number, default: 1 },
    value: { type: [String, Number], required: true },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.t-Slider {
    appearance: none;
    border-radius: 20px;
    height: 6px;
    width: 100%;
    background-color: var(--track-color-bluegray-20);
    &:hover {
        opacity: 1;
    }
    &::-webkit-slider-thumb {
        appearance: none;
        width: 15px;
        height: 15px;
        border-radius: 25px;
        background: var(--track-color-positive-medium);
        cursor: pointer;
    }
    &::-moz-range-thumb {
        appearance: none;
        width: 15px;
        height: 15px;
        border-radius: 25px;
        background: var(--track-color-positive-medium);
        cursor: pointer;
    }
}

</style>
